import React from 'react'
import {connect} from 'react-redux';

import compose from 'recompose/compose';
import { withStyles } from 'material-ui/styles';
import StatusComponent from './StatusComponent';
import {
  getCopperCount,
  getPressedThickness,
  getTotalThickness,
  getHoveredLayer,
  getLengthUnit,
} from '../../../../reducers';

const styles = () =>({
  root: {
    position: 'fixed'
  },
});

export const Status = (props) => <StatusComponent {...props} />;

function mapStateToProps(state){
  return {
    copperCount: getCopperCount(state),
    pressedThickness: getPressedThickness(state),
    totalThickness: getTotalThickness(state),
    hoveredLayer: getHoveredLayer(state),
    lengthUnit: getLengthUnit(state),
  }
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(Status);



// WEBPACK FOOTER //
// ./src/components/StackupDesign/Viewer/StackupEditor/Status.js